// Three visual scent notes per fragrance, selected from the saved scent map.
const scentIcons = {
  'apple-harvest': [['apple', 'Apple'], ['cinnamon', 'Cinnamon'], ['vanilla', 'Vanilla']],
  'apples-and-maple-bourbon': [['apple', 'Apple'], ['bourbon', 'Bourbon'], ['maple', 'Maple']],
  'pumpkin-spice-buttercream': [['pumpkin', 'Pumpkin'], ['cinnamon', 'Cinnamon'], ['vanilla', 'Vanilla']],
  'cranberry-woods': [['berries', 'Cranberry'], ['pine', 'Pine'], ['cinnamon', 'Cinnamon']],
  'white-birch': [['eucalyptus', 'Eucalyptus'], ['pine', 'Pine'], ['smoke', 'Smoke']],
  'egyptian-amber': [['amber', 'Amber'], ['wood', 'Sandalwood'], ['musk', 'Musk']],
  'marrakesh-market': [['cardamom', 'Cardamom'], ['saffron', 'Saffron'], ['incense', 'Incense']],
  'love-spell': [['peach', 'Peach'], ['blossom', 'Cherry blossom'], ['vanilla', 'Vanilla']],
  'blood-orange': [['orange', 'Orange'], ['grapefruit', 'Grapefruit'], ['wood', 'Cedar']],
  'jamaica-me-crazy': [['pineapple', 'Pineapple'], ['coconut', 'Coconut'], ['rum', 'Rum']],
};

const shapes = {
  apple: '<path d="M16 9c-3-5-10-3-10 4 0 7 5 13 10 10 5 3 10-3 10-10 0-7-7-9-10-4Z"/><path d="M16 9c-1-4 1-7 4-8M17 6c3 0 5-1 6-4-3-1-5 1-6 4"/>',
  cinnamon: '<path d="m6 24 13-17c2-2 6 0 4 3L10 27c-3 3-7-1-4-3Zm7 1L25 9M8 24l2 2M19 8l3 2"/><path d="m8 16-4-3 5-7 6 4"/>',
  vanilla: '<path d="M6 28C11 20 13 8 22 3 18 10 19 20 10 28M13 28C21 19 22 12 27 7"/><path d="M8 5C2 1 1 9 7 9c-6 3-1 9 2 4 3 5 8 0 3-3 6-1 3-7-1-5-1-5-5-4-3 0Z"/>',
  bourbon: '<path d="m6 11 2 16h16l2-16H6ZM7 18h18M11 14h5v6h-5zM18 13l4 2-2 4-4-2z"/>',
  maple: '<path d="m16 3 4 8 5-3-1 7 5 2-9 6 1 4-5-1-5 1 1-4-9-6 5-2-1-7 5 3 4-8ZM16 17v13"/>',
  pumpkin: '<path d="M16 9c-12-6-18 15-6 18 3 1 4 0 6-1 2 1 3 2 6 1 12-3 6-24-6-18Z"/><ellipse cx="16" cy="18" rx="5" ry="9"/><path d="M15 9c-2-4 0-7 4-7l-1 7"/>',
  berries: '<circle cx="10" cy="19" r="6"/><circle cx="22" cy="20" r="6"/><circle cx="17" cy="11" r="6"/><path d="M16 5V2M17 5c5-5 9 0 5 3M8 16h2M20 17h2M15 8h2"/>',
  pine: '<path d="m16 2-7 9h4l-7 8h6l-8 8h24l-8-8h6l-7-8h4l-7-9ZM16 27v4"/>',
  eucalyptus: '<path d="M13 30 18 4"/><ellipse cx="11" cy="10" rx="6" ry="3" transform="rotate(25 11 10)"/><ellipse cx="23" cy="15" rx="6" ry="3" transform="rotate(-25 23 15)"/><ellipse cx="9" cy="22" rx="6" ry="3" transform="rotate(25 9 22)"/>',
  smoke: '<path d="M9 28c-10-9 10-10 1-19M17 29c-9-8 10-12 0-20M24 23c-6-7 7-9 0-18M17 5l-1-2"/>',
  amber: '<path d="m11 3 11 2 7 11-7 13-14-3L3 14l8-11ZM11 3l-1 13 12 13M10 16l19 0M22 5l-6 10"/>',
  wood: '<ellipse cx="23" cy="17" rx="6" ry="11"/><ellipse cx="23" cy="17" rx="2.5" ry="6"/><path d="M23 6 8 3C0 5 0 23 8 25l15 3M7 9l10 2M6 17l10 2"/>',
  musk: '<path d="M5 23c-3-6 1-10 6-8 0-7 10-7 10 0 6-2 10 5 5 9M9 27c4 2 10 2 14 0M12 10c-3-3 3-5 0-8M20 10c-3-3 3-5 0-8"/>',
  cardamom: '<path d="M15 3C3 6 0 19 8 26c8 6 18-6 14-18l-7-5Z"/><path d="M15 3c-7 8-10 16-7 23M15 3c4 9 1 18-7 23M24 18c7-1 8 9 1 11"/>',
  saffron: '<path d="M16 21C4 21 1 7 8 6c6 0 9 9 8 15ZM16 21c12 0 15-14 8-15-6 0-9 9-8 15ZM16 20c-6-6-6-17 0-18 6 1 6 12 0 18ZM16 21v10"/><path d="M13 15v8M19 15v8"/>',
  incense: '<path d="M3 28h26M7 25l16-17M19 10l4 3M23 7c-7-4 4-5-1-7"/>',
  peach: '<path d="M16 10C6 2 1 13 5 22s12 8 19 1S27 3 16 10Z"/><path d="M16 10c-5 4-5 13-1 18M16 8c0-6 7-8 10-4-3 4-6 5-10 4"/>',
  blossom: '<path d="M16 11C5-5 3 12 10 15-7 16 7 29 13 22c2 18 15 5 8-1 17 1 9-14 1-10 5-16-11-10-6 0Z"/><circle cx="16" cy="16" r="3"/>',
  orange: '<circle cx="16" cy="18" r="11"/><path d="M16 7V3M16 5c4-5 9-1 8 2-4 1-6 0-8-2M8 18v1M11 24h1M22 19h1"/>',
  grapefruit: '<circle cx="16" cy="16" r="13"/><circle cx="16" cy="16" r="10"/><path d="M16 6v20M6 16h20M9 9l14 14M23 9 9 23"/>',
  pineapple: '<path d="M12 11 7 3l7 3 2-5 2 5 7-3-5 8"/><ellipse cx="16" cy="20" rx="9" ry="10"/><path d="m9 14 13 13M7 20l9 10M15 10l10 10M23 14 10 27M25 20l-9 10M17 10 7 20"/>',
  coconut: '<path d="M3 13c0 20 26 20 26 0"/><ellipse cx="16" cy="13" rx="13" ry="8"/><ellipse cx="16" cy="13" rx="9" ry="5"/><path d="m7 20 3 3M22 23l3-3"/>',
  rum: '<path d="M12 2h8v6l5 6v14H7V14l5-6V2ZM12 5h8M7 17h18M7 25h18"/><circle cx="16" cy="21" r="2"/>',
};

function renderScentIcons(id) {
  return `<div class="scent-icon-row" aria-label="Three key scent notes">${scentIcons[id].map(([icon, label]) => `<span class="scent-note"><svg viewBox="0 0 32 32" aria-hidden="true">${shapes[icon]}</svg><span>${label}</span></span>`).join('')}</div>`;
}

const PRICE = 40;
const PACKS = 3;

function packCount(bundle) {
  return Object.values(bundle.scents).reduce((sum, quantity) => sum + quantity, 0);
}

function changePack(bundle, scentId, delta) {
  const next = (bundle.scents[scentId] || 0) + delta;
  if (next < 0 || packCount(bundle) + delta > PACKS) return bundle;
  const scents = { ...bundle.scents, [scentId]: next };
  if (next === 0) delete scents[scentId];
  return { ...bundle, scents };
}

function isComplete(bundle, catalog) {
  return Boolean(bundle && catalog.warmers.some(w => w.id === bundle.warmer)
    && bundle.scents && typeof bundle.scents === 'object'
    && Object.entries(bundle.scents).every(([id, n]) => catalog.scents.some(s => s.id === id)
      && Number.isInteger(n) && n > 0 && n <= PACKS)
    && packCount(bundle) === PACKS);
}

function bundleItems(draft, catalog) {
  if (!isComplete(draft, catalog)) return null;
  const warmer = catalog.warmers.find(product => product.id === draft.warmer);
  const scents = Object.entries(draft.scents).map(([id, quantity]) => ({
    product: catalog.scents.find(product => product.id === id), quantity
  }));
  if (!warmer?.available || !warmer.variantId || warmer.requiresSellingPlan || scents.some(({product}) => !product?.available || !product.variantId || product.requiresSellingPlan)) return null;
  return [{id: warmer.variantId, quantity: 1}, ...scents.map(({product, quantity}) => ({id: product.variantId, quantity}))];
}

(() => {
  const data = JSON.parse(document.querySelector('#lume-shop-data').textContent);
  const catalog = data;
  const labels = data.labels;
  const dialog = document.querySelector('#shop-dialog');
  const body = document.querySelector('#dialog-body');
  const footer = document.querySelector('#dialog-footer');
  const title = document.querySelector('#dialog-title');
  title.setAttribute('tabindex', '-1');
  let mode = 'warmers', step = 'warmers', draft = { warmer: data.warmers.find(p => p.available && !p.requiresSellingPlan)?.id, scents: {} }, returnFocus, adding = false;
  // Wax packs in the Monthly Scent Box being picked: 6 or 8, from the box size the shopper chooses.
  let boxSize = 6;
  const word = n => (labels.number_words || '').split('|')[n - 1] || String(n);
  const fill = (text, values) => text.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
  let subscriptionDraft = {scents: {}};
  let subscriptionScents = [];
  let cart = data.cart || {items: [], item_count: 0}, refreshing = false;
  const messages = new Map();
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const price = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD',minimumFractionDigits:2}).format((cents || 0)/100);
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD',minimumFractionDigits:0,maximumFractionDigits:2}).format((cents || 0)/100);
  // Card photos ask Shopify's CDN for a size that fits the card instead of the full master.
  const photo = (url, sizes) => { const at = w => `${url}${url.includes('?') ? '&' : '?'}width=${w}`; return `src="${at(540)}" srcset="${[360,540,720].map(w=>`${at(w)} ${w}w`).join(', ')}" sizes="${sizes}"`; };
  const cardSizes = '(max-width: 700px) calc(50vw - 27px), 310px';
  const unavailable = product => product?.variantId ? labels.sold_out : labels.unavailable;
  const oneTimeLine = (item, id) => !item.selling_plan_allocation && String(item.variant_id || item.id) === String(id);
  const variantQuantity = id => cart.items.filter(item => oneTimeLine(item, id)).reduce((total, item) => total + item.quantity, 0);
  // Taps update the count at once; `wanted` holds those counts until Shopify confirms them.
  const wanted = new Map();
  const tries = new Map();
  let syncing = null, cartWrites = 0;
  const shown = id => wanted.has(String(id)) ? wanted.get(String(id)) : variantQuantity(id);
  const shownTotal = () => cart.item_count + [...wanted].reduce((total, [id, count]) => total + count - variantQuantity(id), 0);
  function productControls(p) {
    if (p.requiresSellingPlan) return `<a href="${escape(p.url)}">${escape(labels.view_product)}</a>`;
    const count = shown(p.variantId);
    return `<div class="bag-control" data-bag-variant="${p.variantId || ''}" data-bag-name="${escape(p.name)}" data-available="${Boolean(p.available)}"><div class="stepper" role="group" aria-label="${escape(p.name+' '+labels.quantity)}"><button type="button" data-bag-delta="-1" aria-label="${escape(labels.remove+' '+p.name)}" ${!count || adding ? 'disabled' : ''}>−</button><output aria-live="polite" aria-label="${escape(p.name+' '+labels.quantity)}">${count}</output><button type="button" data-bag-delta="1" aria-label="${escape(labels.increase+' '+p.name)}" ${!p.available || adding ? 'disabled' : ''}>+</button></div><span class="stock-status" ${p.available ? 'hidden' : ''}>${escape(unavailable(p))}</span><p class="bag-feedback" role="status" hidden></p><p class="bag-error notice" role="alert" hidden></p></div>`;
  }
  function syncControls() {
    const focused = document.activeElement;
    document.querySelectorAll('[data-bag-variant]').forEach(control => {
      const id = control.dataset.bagVariant, count = shown(id), message = messages.get(id);
      control.querySelector('output').textContent = count;
      control.querySelector('[data-bag-delta="-1"]').disabled = adding || count === 0;
      control.querySelector('[data-bag-delta="1"]').disabled = adding || control.dataset.available !== 'true' || control.dataset.requiresSellingPlan === 'true' || !id;
      control.setAttribute('aria-busy', String(adding || wanted.has(id)));
      const stock = control.querySelector('.stock-status');
      if (stock) stock.hidden = control.dataset.available === 'true';
      const feedback = control.querySelector('.bag-feedback'), error = control.querySelector('.bag-error');
      feedback.hidden = !message || Boolean(message.error);
      feedback.textContent = message?.error ? '' : message?.text || '';
      error.hidden = !message?.error;
      error.innerHTML = message?.error ? `${escape(message.text)} <a href="${escape(data.routes.cart)}">${escape(labels.review_bag)}</a>` : '';
      // A button that just became disabled (minus at zero) hands focus to its neighbour.
      if (focused?.disabled && control.contains(focused)) control.querySelector('button:not(:disabled)')?.focus({preventScroll: true});
    });
    const badge = document.querySelector('#bag-count');
    const total = shownTotal();
    if (badge) { badge.textContent = total; badge.hidden = total === 0; }
    document.querySelector('.bag-button')?.setAttribute('aria-label', `${labels.bag}, ${total} ${total === 1 ? 'item' : 'items'}`);
    const bundleButton = footer.querySelector('#bundle-form button');
    if (bundleButton) bundleButton.disabled = adding || !bundleItems(draft, data);
  }
  const validCart = current => Array.isArray(current?.items) && Number.isSafeInteger(current.item_count);
  async function readCart() {
    const writesBefore = cartWrites;
    const response = await fetch(data.routes.cart + '.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
    const current = await response.json();
    if (!response.ok || !validCart(current)) throw new Error(labels.bag_error);
    // A read that overlapped a bag change may predate it, so the change's own answer wins.
    if (writesBefore === cartWrites) cart = current;
    syncControls();
    return current;
  }
  async function refreshCart() {
    if (adding || refreshing || syncing) return;
    refreshing = true;
    syncControls();
    try { await readCart(); } catch {}
    finally { refreshing = false; syncControls(); }
  }
  function changeBag(control, delta) {
    if (adding || ![-1, 1].includes(delta)) return;
    const id = control.dataset.bagVariant;
    if (!id || (delta > 0 && (control.dataset.available !== 'true' || control.dataset.requiresSellingPlan === 'true'))) return;
    const next = shown(id) + delta;
    if (next < 0) return;
    wanted.set(id, next);
    messages.delete(id);
    syncControls();
    if (!syncing) syncing = sendBag().finally(() => { syncing = null; });
    return syncing;
  }
  // Sends one change at a time, so quick taps merge into the next request instead of racing each other.
  async function sendBag() {
    for (let entry = wanted.entries().next(); !entry.done; entry = wanted.entries().next()) {
      const [id, target] = entry.value;
      const lines = cart.items.filter(item => oneTimeLine(item, id)), line = lines.at(-1);
      const difference = target - lines.reduce((total, item) => total + item.quantity, 0);
      try {
        if (difference) {
          const request = difference > 0 || !line ? [data.routes.add + '.js', {items: [{id: Number(id), quantity: difference}]}]
            : [data.routes.cart + '/change.js', {id: line.key, quantity: Math.max(0, line.quantity + difference)}];
          cartWrites++;
          try {
            const response = await fetch(request[0], {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(request[1])});
            const result = await response.json();
            if (!response.ok) throw new Error(response.status === 422 ? labels.quantity_unavailable : labels.bag_error);
            if (validCart(result)) cart = result;
          } finally { cartWrites++; }
          if (!request[0].endsWith('/change.js')) await readCart();
        }
        // More taps arrived, or the change only reached one of several lines: go again.
        if (wanted.get(id) !== target) continue;
        if (variantQuantity(id) !== target && difference && (tries.set(id, (tries.get(id) || 0) + 1).get(id)) < 3) continue;
        wanted.delete(id); tries.delete(id);
        messages.set(id, variantQuantity(id) === target ? {text: labels.bag_updated} : {error: true, text: labels.bag_error});
      } catch (failure) {
        try { await readCart(); } catch {}
        wanted.delete(id); tries.delete(id);
        if (variantQuantity(id) === target) messages.set(id, {text: labels.bag_updated});
        else messages.set(id, {error: true, text: failure.message === labels.quantity_unavailable ? labels.quantity_unavailable : labels.bag_error});
      }
      syncControls();
    }
  }
  function warmers(selectable=false, items=data.warmers) {
    return `<div class="product-grid">${items.map(p=>selectable ? `<button class="product-card ${draft.warmer===p.id?'selected':''}" data-warmer="${p.id}" ${p.available && !p.requiresSellingPlan ? '' : 'disabled'} aria-pressed="${draft.warmer===p.id}"><img ${photo(p.image, cardSizes)} alt="${escape(p.name)}" width="720" height="720" loading="lazy"><span class="product-name">${escape(p.name)}</span>${!p.available ? `<span class="stock-status">${escape(unavailable(p))}</span>` : ''}${draft.warmer===p.id?'<span class="selected-mark" aria-hidden="true">✓</span>':''}</button>` : `<article class="product-card"><a href="${escape(p.url)}"><img ${photo(p.image, cardSizes)} alt="${escape(p.name)}" width="720" height="720" loading="lazy"><span class="product-name">${escape(p.name)}</span></a><div class="product-buy"><span class="single-price">${money(p.price)}</span>${productControls(p)}</div></article>`).join('')}</div>`;
  }
  function scents(selectable=false, items=data.scents, selection=draft, limit=3) {
    return `<div class="scent-list scent-grid">${items.map(s=>{
      const n=selection.scents[s.id]||0;
      const control=selectable ? `<div class="stepper"><button type="button" data-scent="${s.id}" data-delta="-1" aria-label="${escape(labels.remove+' '+s.name)}" ${!n?'disabled':''}>−</button><output aria-label="${escape(s.name+' '+labels.quantity)}">${n}</output><button type="button" data-scent="${s.id}" data-delta="1" aria-label="${escape(labels.add+' '+s.name)}" ${packCount(selection)>=limit||!s.available||s.requiresSellingPlan?'disabled':''}>+</button></div>` : '';
      const buy=selectable ? `<div class="scent-buy">${control}</div>` : `<div class="scent-buy single-scent-buy"><span class="scent-price">${price(s.price)}</span>${productControls(s)}</div>`;
      return `<article class="scent-card"><a class="scent-card-image" href="${escape(s.url)}"><img ${photo(s.image, cardSizes)} alt="${escape(s.name)}" width="360" height="360" loading="lazy"></a><div class="scent-content"><span class="tag">${escape(s.family)}</span><h3>${escape(s.name)}</h3>${renderScentIcons(s.id)}<button type="button" class="notes-link" data-notes="${s.id}" aria-haspopup="dialog">${escape(labels.notes)}</button></div>${buy}</article>`;
    }).join('')}</div>`;
  }
  // Scent notes open in their own small window above the shop dialog, so the grid stays compact.
  let notesWindow, notesReturn;
  function openNotes(trigger) {
    const s = data.scents.find(scent => scent.id === trigger.dataset.notes);
    if (!s) return;
    if (!notesWindow) {
      notesWindow = document.createElement('dialog');
      notesWindow.className = 'notes-window';
      notesWindow.setAttribute('aria-labelledby', 'notes-title');
      notesWindow.addEventListener('click', e => { if (e.target === notesWindow || e.target.closest('.close-notes')) notesWindow.close(); });
      notesWindow.addEventListener('close', () => { notesReturn?.focus(); notesReturn = null; });
      document.body.append(notesWindow);
    }
    notesReturn = trigger;
    notesWindow.innerHTML = `<div class="notes-window-header"><div><span class="tag">${escape(s.family)}</span><h2 id="notes-title">${escape(s.name)}</h2></div><button type="button" class="close-notes" aria-label="${escape(labels.close)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><img ${photo(s.image, '(max-width: 420px) calc(100vw - 76px), 376px')} alt="" width="360" height="360">${s.summary ? `<p class="notes-summary">${escape(s.summary)}</p>` : ''}${renderScentIcons(s.id)}<dl class="notes-list">${Object.entries(s.notes).map(([k,v])=>`<dt>${escape(k)}</dt><dd>${escape(v.join(', '))}</dd>`).join('')}</dl>`;
    notesWindow.showModal();
    notesWindow.querySelector('.close-notes').focus();
  }
  function syncSubscription() {
    const count = packCount(subscriptionDraft);
    body.querySelectorAll('[data-scent]').forEach(button => {
      const product = subscriptionScents.find(scent => scent.id === button.dataset.scent);
      const quantity = subscriptionDraft.scents[button.dataset.scent] || 0;
      button.disabled = Number(button.dataset.delta) > 0 ? count >= boxSize || !product : quantity === 0;
      button.parentElement.querySelector('output').textContent = quantity;
    });
    const form = body.querySelector('.monthly-scent-form');
    const choices = subscriptionScents.flatMap(scent => Array(subscriptionDraft.scents[scent.id] || 0).fill(scent.id));
    // Slots past the chosen size are switched off so they are never submitted.
    form.querySelectorAll('.subscription-slots select').forEach((select, index) => {
      select.disabled = index >= boxSize; select.required = index < boxSize;
      select.value = index < boxSize ? [...select.options].find(option => option.dataset.scentId === choices[index])?.value || '' : '';
    });
    const size = form.querySelector('.subscription-sizes input:checked');
    document.querySelector('#dialog-kicker').textContent = `${labels.monthly_box} · ${fill(labels.per_month, {price: size?.dataset.price || ''})}`;
    title.textContent = fill(labels.pick_size, {count: word(boxSize)});
    footer.querySelector('.bundle-counter').textContent = `${count} ${fill(labels.size_selected, {count: boxSize})}`;
    footer.querySelector('button').disabled = count !== boxSize;
  }
  const subscription = (() => { try { return JSON.parse(document.querySelector('#lume-subscription')?.textContent || '{}'); } catch { return {}; } })();
  function openLockedSubscription(trigger) {
    const counts = {};
    subscription.scents.forEach(entry => { const key = entry.id || entry.name; counts[key] = (counts[key] || 0) + 1; });
    const known = Object.keys(counts).map(id => data.scents.find(scent => scent.id === id)).filter(Boolean);
    const unknown = Object.keys(counts).filter(id => !data.scents.some(scent => scent.id === id));
    if (!dialog.open) returnFocus = trigger;
    mode = 'locked';
    dialog.classList.remove('menu-window');
    dialog.classList.add('subscription-window');
    const size = subscription.size || subscription.scents.length;
    document.querySelector('#dialog-kicker').textContent = labels.monthly_box;
    title.textContent = fill(subscription.next ? labels.this_month_size : labels.your_size, {count: word(size)});
    body.innerHTML = (subscription.status === 'paused' ? `<p class="subscription-status" role="status">${escape(labels.subscription_paused)}</p>` : '') + scents(true, known, {scents: counts}, size) + unknown.map(name => `<p class="locked-scent">${escape(name)} × ${counts[name]}</p>`).join('');
    body.querySelectorAll('[data-scent]').forEach(button => { button.disabled = true; });
    footer.innerHTML = subscription.next
      ? `<a class="primary" href="${escape(subscription.next)}">${escape(fill(labels.choose_next_size, {count: word(size)}))}</a><a class="text-button manage-link" href="${escape(subscription.account)}">${escape(labels.manage_subscription)}</a>`
      : `<p class="bundle-counter">${subscription.scents.length} ${escape(fill(labels.size_selected, {count: size}))}</p><a class="primary" href="${escape(subscription.account)}">${escape(labels.manage_subscription)}</a>`;
    if (!dialog.open) dialog.showModal();
    body.scrollTop = 0;
    title.focus({preventScroll: true});
    return true;
  }
  function openSubscription(trigger) {
    // Subscribers go straight to My Scents, which shows this month's box and next month's picker on one page.
    if (subscription.next && (subscription.scents?.length || ['active', 'paused'].includes(subscription.status))) { location.assign(subscription.next); return true; }
    if (subscription.scents?.length) return openLockedSubscription(trigger);
    const source = document.querySelector('#subscription-form-template');
    const form = source?.content.querySelector('.monthly-scent-form')?.cloneNode(true);
    if (!form) return false;
    if (!dialog.open) returnFocus = trigger;
    mode = 'subscription';
    subscriptionDraft = {scents: {}};
    const options = [...form.querySelector('select').options];
    subscriptionScents = data.scents.filter(scent => scent.available && scent.variantId && !scent.requiresSellingPlan && options.some(option => option.dataset.scentId === scent.id));
    form.setAttribute('id', 'monthly-window-form');
    form.querySelectorAll('select').forEach(select => { select.id = `window-${select.id}`; });
    form.querySelectorAll('.subscription-slots label').forEach(label => { label.htmlFor = `window-${label.htmlFor}`; });
    dialog.classList.remove('menu-window');
    dialog.classList.add('subscription-window');
    boxSize = Number(form.querySelector('.subscription-sizes input:checked')?.dataset.size) || 6;
    body.innerHTML = '';
    const list = document.createElement('div');
    list.innerHTML = scents(true, subscriptionScents, subscriptionDraft, boxSize);
    // The 6-pack / 8-pack choice sits above the scents.
    form.querySelector('.subscription-sizes').after(list.firstElementChild);
    const submit = form.querySelector('button[type="submit"]');
    submit.setAttribute('form', 'monthly-window-form');
    footer.innerHTML = '<p class="bundle-counter" aria-live="polite"></p>';
    footer.append(submit);
    body.append(form);
    if (subscription.status && subscription.status !== 'paused' && subscription.status !== 'active') form.insertAdjacentHTML('afterbegin', `<p class="subscription-status" role="status">${escape(subscription.status === 'cancelled' ? labels.subscription_canceled : labels.subscription_ended)}</p>`);
    syncSubscription();
    if (!dialog.open) dialog.showModal();
    body.scrollTop = 0;
    title.focus({preventScroll: true});
    return true;
  }
  function bundleForm() {
    const warmer=data.warmers.find(w=>w.id===draft.warmer);
    return `<p class="bundle-counter" aria-live="polite">${packCount(draft)} ${escape(labels.selected)}</p><form id="bundle-form"><button type="submit" class="primary" ${!bundleItems(draft, data) ? 'disabled':''}>${escape(warmer?.available ? labels.add_bundle : unavailable(warmer))}</button><p id="bundle-error" class="notice" role="alert" hidden></p></form>`;
  }

  // Updates the bundle scent steppers in place so the list, its images and scroll position stay put.
  function syncBundle() {
    const total = packCount(draft);
    body.querySelectorAll('[data-scent]').forEach(button => {
      const s = data.scents.find(scent => scent.id === button.dataset.scent), n = draft.scents[button.dataset.scent] || 0;
      button.disabled = Number(button.dataset.delta) > 0 ? total >= 3 || !s?.available || s.requiresSellingPlan : !n;
      button.parentElement.querySelector('output').textContent = n;
    });
    const stepButton = body.querySelector('.step-nav [data-step="scents"]');
    if (stepButton) stepButton.textContent = `${labels.step_scents} (${total}/3)`;
    footer.innerHTML = bundleForm();
    syncControls();
  }

  function render() {
    dialog.classList.remove('subscription-window', 'menu-window');
    footer.innerHTML='';
    document.querySelector('#dialog-kicker').textContent=mode==='bundle'?labels.cozy+' · $40':'LUME';
    if(mode==='warmers') { title.textContent=labels.find_glow;body.innerHTML=warmers(); }
    if(mode==='scents') { title.textContent=labels.find_fragrance;body.innerHTML=scents(); }
    if(mode==='warmers'||mode==='scents') footer.innerHTML=`<button class="primary" data-open="bundle">${escape(labels.build)}</button>`;
    if(mode==='bundle') {
      title.textContent=step==='warmers'?labels.choose_warmer:labels.pick_three;
      body.innerHTML=`<nav class="step-nav"><button data-step="warmers" class="${step==='warmers'?'active':''}" ${step==='warmers'?'aria-current="step"':''}>${escape(labels.step_warmer)}</button><button data-step="scents" class="${step==='scents'?'active':''}" ${step==='scents'?'aria-current="step"':''}>${escape(labels.step_scents)} (${packCount(draft)}/3)</button></nav>`+(step==='warmers'?warmers(true):`<p class="intro">${escape(labels.repeat)}</p>`+scents(true));
      footer.innerHTML=step==='warmers'?`<button class="primary" data-step="scents" ${data.warmers.some(w=>w.id===draft.warmer&&w.available&&!w.requiresSellingPlan)?'':'disabled'}>${escape(labels.next)}</button>`:bundleForm();
    }
    if(mode==='search') {
      title.textContent=labels.find;
      body.innerHTML=`<label class="eyebrow" for="drawer-search">${escape(labels.search_label)}</label><input type="search" id="drawer-search" class="search-input" placeholder="${escape(labels.search_placeholder)}"><div id="search-results"></div>`;
      search('');
    }
    syncControls();
    if(mode==='menu') { dialog.classList.add('menu-window');title.textContent=labels.menu_title;body.innerHTML=`<nav class="menu-links"><button data-open="warmers">${escape(labels.warmers)}</button><button data-open="scents">${escape(labels.scents)}</button><button data-open="bundle">${escape(labels.bundle_menu)}</button>${document.querySelector('#subscription-menu-link')?.innerHTML || ''}${document.querySelector('#account-menu-link')?.innerHTML || ''}</nav>`; }
  }
  function search(value) {
    const q=value.trim().toLowerCase();
    const ws=data.warmers.filter(p=>p.name.toLowerCase().includes(q));
    const ss=data.scents.filter(p=>[p.name,p.family,...Object.values(p.notes).flat()].join(' ').toLowerCase().includes(q));
    document.querySelector('#search-results').innerHTML=(!ws.length&&!ss.length)?`<p class="intro">${escape(labels.none)}</p>`:(ws.length?`<h3 class="search-heading">${escape(labels.warmers)}</h3>`+warmers(false,ws):'')+(ss.length?`<h3 class="search-heading">${escape(labels.scents)}</h3>`+scents(false,ss):'');
    syncControls();
  }
  document.addEventListener('click',e=>{
    const subscriptionTrigger = e.target.closest('[data-subscription-open]');
    if (subscriptionTrigger && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && openSubscription(subscriptionTrigger)) { e.preventDefault(); return; }
    const b=e.target.closest('button');if(!b||b.disabled)return;
    if(b.dataset.notes){openNotes(b);return;}
    if(b.dataset.bagDelta){return changeBag(b.closest('[data-bag-variant]'),Number(b.dataset.bagDelta));}
    if(b.classList.contains('close-dialog')) {dialog.close();return;}
    if(b.dataset.open){refreshCart();if(!dialog.open)returnFocus=document.activeElement;mode=b.dataset.open;if(mode==='bundle')step='warmers';render();if(!dialog.open)dialog.showModal();body.scrollTop=0;if(mode==='search')document.querySelector('#drawer-search').focus();else title.focus({preventScroll:true});return;}
    if(b.dataset.step){step=b.dataset.step;render();body.scrollTop=0;title.focus({preventScroll:true});return;}
    if(b.dataset.warmer&&!data.warmers.some(w=>w.id===b.dataset.warmer&&w.available&&!w.requiresSellingPlan))return;
    if(b.dataset.warmer){draft.warmer=b.dataset.warmer;render();body.querySelector(`[data-warmer="${draft.warmer}"]`)?.focus({preventScroll:true});return;}
    if(b.dataset.scent && mode === 'subscription') {
      const id = b.dataset.scent, delta = Number(b.dataset.delta);
      if (!subscriptionScents.some(scent => scent.id === id) || ![-1, 1].includes(delta)) return;
      const quantity = subscriptionDraft.scents[id] || 0;
      if ((delta > 0 && packCount(subscriptionDraft) >= boxSize) || (delta < 0 && quantity === 0)) return;
      subscriptionDraft.scents[id] = quantity + delta;
      syncSubscription();
      if (b.disabled) b.parentElement.querySelector(`button[data-delta="${-delta}"]`).focus({preventScroll:true});
      return;
    }
    if(b.dataset.scent){draft=changePack(draft,b.dataset.scent,Number(b.dataset.delta));syncBundle();const same=body.querySelector(`[data-scent="${b.dataset.scent}"][data-delta="${b.dataset.delta}"]`);const other=body.querySelector(`[data-scent="${b.dataset.scent}"][data-delta="${-Number(b.dataset.delta)}"]`);(same.disabled?other:same).focus({preventScroll:true});}
  });
  footer.addEventListener('submit', async event => {
    if (event.target.id !== 'bundle-form') return;
    event.preventDefault();
    if (adding) return;
    if (syncing) await syncing;
    const items = bundleItems(draft, data);
    if (!items) return;
    const button = event.target.querySelector('button');
    const error = event.target.querySelector('#bundle-error');
    adding = true;
    syncControls();
    button.disabled = true;
    button.textContent = labels.adding;
    error.hidden = true;
    try {
      const response = await fetch(data.routes.add + '.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(response.status === 422 ? labels.quantity_unavailable : labels.cart_error);
      window.location.assign(data.routes.cart);
    } catch (failure) {
      try { await readCart(); } catch {}
      const message = failure.message === labels.quantity_unavailable ? labels.quantity_unavailable : labels.cart_error;
      error.innerHTML = `${escape(message)} <a href="${escape(data.routes.cart)}">${escape(labels.review_bag)}</a>`;
      error.hidden = false;
      button.disabled = false;
      button.textContent = labels.add_bundle;
      adding = false;
      syncControls();
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-bag-options]')) return;
    const select = event.target, control = select.parentElement.querySelector('[data-bag-variant]');
    control.dataset.bagVariant = select.value;
    control.dataset.available = select.selectedOptions[0]?.dataset.available || 'false';
    control.dataset.requiresSellingPlan = select.selectedOptions[0]?.dataset.requiresSellingPlan || 'false';
    const notice = select.parentElement.querySelector('.subscription-required');
    if (notice) notice.hidden = control.dataset.requiresSellingPlan !== 'true';
    syncControls();
  });
  window.addEventListener('pageshow', refreshCart);
  window.addEventListener('focus', refreshCart);
  syncControls();
  refreshCart();
  body.addEventListener('input' ,e=>{if(e.target.id==='drawer-search')search(e.target.value);});
  // Switching to a smaller box drops the extra picks from the end of the list, so the box is never over full.
  body.addEventListener('change', e => {
    if (mode !== 'subscription' || !e.target.matches('.subscription-sizes input')) return;
    boxSize = Number(e.target.dataset.size) || boxSize;
    for (const scent of [...subscriptionScents].reverse()) {
      while (packCount(subscriptionDraft) > boxSize && subscriptionDraft.scents[scent.id]) subscriptionDraft.scents[scent.id]--;
    }
    syncSubscription();
  });
  dialog.addEventListener('close',()=>{
    if (mode === 'subscription' || mode === 'locked') { subscriptionDraft = {scents: {}}; body.innerHTML = ''; footer.innerHTML = ''; dialog.classList.remove('subscription-window'); }
    returnFocus?.focus();
  });
  const subscriptionPage = document.querySelector('[data-subscription-page]');
  if (subscriptionPage && document.querySelector('#subscription-form-template')?.content.querySelector('.monthly-scent-form')) {
    const reopen = subscriptionPage.querySelector('[data-subscription-open]');
    subscriptionPage.querySelector('.product-detail').hidden = true;
    reopen.hidden = false;
    openSubscription(reopen);
  }
  const accountPage = document.querySelector('[data-subscription-account] [data-subscription-open]');
  if (accountPage) openSubscription(accountPage);
  dialog.addEventListener('click',e=>{if(e.target===dialog && e.clientX<dialog.getBoundingClientRect().left)dialog.close();});
})();
